import { AmplifyConfig, InterfaceConfig } from "@interfaces/index";
import { ThemeApiStructure } from "@interfaces/theme";

export const localTheme: ThemeApiStructure = {
  id:
    import.meta.env.VITE_ENV === "PROD"
      ? "49f931c1-d705-4b02-a710-a5da2e0fdec1"
      : "49f931c1-d705-4b02-a710-a5da2e0fdec1",
  name: "banbajio",
  display_name: "Banbajio",
  description: "",
  code: "",
  url_site: "/solicita_tu_credito",
  url_privacy_notice: import.meta.env.VITE_URL_HOME_LENDIA + "/aviso-de-privacidad",
  url_terms_and_conditions: import.meta.env.VITE_URL_HOME_LENDIA + "/terminos-y-condiciones",
  palette: {
    palette: {
      primary: {
        base: "#DEC4FF", // base 30%
        dark: "#2A2A2A", // obscuro
        main: "#763DBE", // color 2
        light: "#F4D8FF", // color 1
        accent: "#763DBE", // accents
      },
      components: {},
    },
    interface: {
      navbar: {
        logo: "banbajio/portal/logos/logo.png",
        logo_width: 142,
        logo_height: "auto",
      },
      lateral: {
        bg_dark: "#2A2A2A", // obscuro
        bg_light: "#F4D8FF", // color 2 o light
        logo_bg_dark: "banbajio/portal/logos/logo_dark_bg.png",
        text_bg_dark: "#FFFFFF",
        logo_bg_light: "banbajio/portal/logos/logo.png",
        text_bg_light: "#FFFFFF",
        logo_width: 250,
        logo_height: "auto",
      },
      metadata: {
        title: "Banbajio",
        favicon: "banbajio/portal/logos/favicon.ico",
      },
    },
  },
};

// demo-clientes-banbajio.lendia.mx
// demo-clientes-banbajio.lendia.mx
// https://demo-clientes-banbajio.lendia.mx/

export const interfaceConfig: InterfaceConfig = {
  name: "banbajio",
  home_url: "/solicita_tu_credito",
  aviso_privacidad: import.meta.env.VITE_URL_HOME_LENDIA + "/aviso-de-privacidad",
  terminos_condiciones: import.meta.env.VITE_URL_HOME_LENDIA + "/terminos-y-condiciones",
  interest_rate: 30,
  metadata: {
    title: "Banbajio",
    description:
      "En Banbajio comienzan tus inversiones desde cualquier monto. Nuestros especialistas y asesores te ayudarán a lograr tus objetivos financieros. ¡Conocé más!",
    favicon: "banbajio/portal/logos/favicon.ico",
    ogImage: "https://lendia.mx/opengraph-image.png?5ab5b324c6780cbc",
  },
  navbar: {
    logo: "banbajio/portal/logos/logo.png",
    logo_width: 142,
    logo_height: 32,
  },
  lateral: {
    logo_width: 142 * 2,
    logo_height: 32 * 2,
    logo_dark: "banbajio/portal/logos/logo_dark_bg.png",
    bg_light: "#1D3F6E", // color 2
    text_light: "#FFFFFF",
    logo_light: "banbajio/portal/logos/logo.png",
    bg_dark: "##2A2A2A", // obscuro
    text_dark: "#FFFFFF",
    image_list: [
      "lendia/portal/lateral/imagen_1.webp",
      "lendia/portal/lateral/imagen_2.webp",
      "lendia/portal/lateral/imagen_3.webp",
      "lendia/portal/lateral/imagen_4.webp",
      "lendia/portal/lateral/imagen_5.webp",
      "lendia/portal/lateral/imagen_6.webp",
      "lendia/portal/lateral/imagen_7.webp",
      "lendia/portal/lateral/imagen_8.webp",
      "lendia/portal/lateral/imagen_9.webp",
      "lendia/portal/lateral/imagen_10.webp",
    ],
    text_list: [
      "Así de fácil: solicita, compara, avanza",
      "Tu crédito, tu elección, tu crecimiento",
      "Crédito simple, procesos simples",
      "Avanza con las mejores condiciones del mercado",
      "Compara y decide: tu crédito, tus reglas",
      "Un solo lugar, todas las opciones de financiamiento",
      "Crecer nunca fue tan sencillo",
      "Descubre la mejor solución para tu PyME",
      "El poder de elegir está en tus manos",
      "Da el paso que tu empresa necesita",
    ],
  },
  textos_tofu: {
    pm: {
      crear_cuenta: {
        titulo: "Te damos la bienvenida",
        sub_titulo: "",
      },
      registro_datos_personales: {
        titulo: "Creación de cuenta",
        sub_titulo: "",
      },
      validacion_telefono: {
        titulo: "Validación de teléfono",
        sub_titulo: "",
      },
      datos_empresa_pm: {
        titulo: "Registro de empresa",
        sub_titulo: "",
      },
      consulta_ciec: {
        titulo: "Registro de empresa",
        sub_titulo: "",
      },
      uso_de_credito: {
        titulo: "Selección de uso de crédito",
        sub_titulo: "",
      },
      presencia_digital_pm: {
        titulo: "Presencia digital",
        sub_titulo: "",
      },
      datos_accionista: {
        titulo: "Registro del accionista mayoritario",
        sub_titulo: "",
      },
      rfc_curp: {
        titulo: "Registro del accionista mayoritario",
        sub_titulo: "",
      },
      domicilio_accionista: {
        titulo: "Registro del accionista mayoritario",
        sub_titulo: "",
      },
      consulta_buro_nip: {
        titulo: "Validación para consulta buró",
        sub_titulo: "",
      },
      buro_bloqueado: {
        titulo: "Consulta de Buró de Crédito del Accionista Bloqueada",
        sub_titulo: "",
      },
    },

    pfae: {
      datos_empresa_pfae: {
        titulo: "Registro de empresa",
        sub_titulo: "Ingresa los datos de la persona física con actividad empresarial",
      },
      consulta_buro_pfae: {
        titulo: "Consulta Buró",
        sub_titulo: "",
      },
      domicilio_pfae: {
        titulo: "Domicilio",
        sub_titulo: "",
      },
      presencia_digital_pfae: {
        titulo: "Presencia digital",
        sub_titulo: "",
      },
    },
  },
  maps: {
    api_key: import.meta.env.VITE_ENV === "PROD" ? "" : "",
  },
  companyNames: ["Lendit Group SAPI de CV"],
  text_accionista_check:
    "Declaro bajo protesta de decir verdad ser el Accionista mayoritario de la empresa mencionada en esta solicitud.",
};

export const amplifyConfig: AmplifyConfig = {
  dev: {
    client: {
      userPoolId: "us-east-1_BeRV6uYmO",
      userPoolClientId: "208j2kkvh8r32d2a9qq926t33f",
    },
    guarantee: {
      userPoolId: "",
      userPoolClientId: "",
    },
  },
  prod: {
    client: {
      userPoolId: "us-east-1_Y0yNT5nH4",
      userPoolClientId: "78ctmcltm4h9r5g3lgie7fl65f",
    },
    guarantee: {
      userPoolId: "",
      userPoolClientId: "",
    },
  },
};
